import { t } from "i18next";
import { LinkButton } from "~/common/components/Link";
import { styled } from "~/common/mui";
import AddIcon from "@mui/icons-material/Add";

const LabelContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  padding: "8px 0 16px 0",
  "& p": {
    margin: 0,
  },
}));

interface Params {
  openPopup: () => void;
}

export const CreateCaseElement = ({ openPopup }: Params) => {
  return (
    <LabelContainer>
      <p>{t("serviceCases.addCase.label")}</p>
      <LinkButton onClick={openPopup} iconBefore={<AddIcon  />}>
        {t("serviceCases.addCase.button")}
      </LinkButton>
    </LabelContainer>
  );
};
